import { useSuspenseQuery, UseSuspenseQueryOptions } from "@tanstack/react-query";
import { NotiflowWithSteps } from "@/types/entities";
import { api, ErrorResponse } from "@/utils/api";
import { camelize } from "@/utils/api-helpers";

export const useNotiflow = (
  projectId: string,
  notiflowId: string,
  options: Omit<UseSuspenseQueryOptions<unknown, ErrorResponse, NotiflowWithSteps>, "queryKey"> = {}
) => {
  return useSuspenseQuery<unknown, ErrorResponse, NotiflowWithSteps>({
    queryKey: ["projects", projectId, "notiflows", notiflowId],
    queryFn: async (): Promise<NotiflowWithSteps> => {
      const response = await api.get<NotiflowWithSteps>(`/projects/${projectId}/notiflows/${notiflowId}`);
      return camelize(response.data);
    },
    // The editor stays on the version it loaded — don't silently pull the tab to
    // the server's current on window-focus, which would defeat the optimistic
    // concurrency check (you'd never be "stale", so save-time conflicts couldn't fire).
    refetchOnWindowFocus: false,
    ...options
  });
};
